import { Observable } from "rxjs"
import { ServiceTypeCode } from "../Administration/Model/ServiceType"
import { ObservableFromFetch } from "../ObservableFromFetch"
import OrderData from "./OrderRequestsModel/OrderData"

export interface SSOOrderRequestData {
  OrderRequest?: OrderRequest
  Donor?: DonorDetail
}
interface OrderRequest {
  UserName?: string
  Password?: string
  CustomerId?: number
  ExternalUserName?: string
  WFUserName?: string
  ClientID?: number
  CompanyAccount?: number
  ReferenceTestId?: string
  PostBackURL?: string
}
export interface DonorDetail {
  DonorFirstName?: string
  DonorLastName?: string
  DonorID?: string
  DonorIDType?: string
  DonorDOB?: string
  DonorPhone?: string
  DonorEmail?: string
  Donoremail?: string
  Address?: DonorAddress
}
interface DonorAddress {
  Line1?: string
  Line2?: string
  City?: string
  State?: string
  Zip?: string
}
const emptyOrderRequest = {
  UserName: "",
  Password: "",
  CustomerId: 0,
  ExternalUserName: "",
  WFUserName: "",
  ClientID: 0,
  CompanyAccount: 0,
  ReferenceTestId: "",
  PostBackURL: ""
}
const emptyDonorAddress = {
  Line1: "",
  Line2: "",
  City: "",
  State: "",
  Zip: ""
}
const emptyDonorDetail = {
  DonorFirstName: "",
  DonorLastName: "",
  DonorID: "",
  DonorIDType: "",
  DonorDOB: "",
  DonorPhone: "",
  Donoremail: "",
  Address: emptyDonorAddress
}

export const EmptySSOOrderRequestData = {
  OrderRequest: emptyOrderRequest,
  Donor: emptyDonorDetail
}

export interface EmbededTestEventWithDetail {
  TestEventID: number
  PersonID: number
  ImplementationID: number
  OrderUserLoginID: number
  FirstName: string
  LastName:  string
  SSN:  string
  EmployerID:  string
  AllowDonorClinicSelect: boolean
  TestDetailID: number
  DOT: boolean
  FLEX: boolean
  Observed: boolean
  LabCode: string
  FormFoxTestAN: number
  FormFoxVendorAN: number
  FFVendorCode: string
  TestTypeID: number
  TestTypeDescription: ServiceTypeCode
  SampleTypeID: number
  SampleTypeDescription: string
  SampleTypeCode: string
  SampleTypeIsPoct: boolean
  SampleTypeIsAlcohol: boolean
  FFCode: string
  IsClinical: boolean
}

export interface FFSiteSearchData {
  DefaultAddress: string
  Radius: number
  CallbackLink: string
  ReferenceTestID: number
  PriceTierOverride?: string[]
}

export interface PendingOrderRequest {
  OrderRequestID: number
  ExternalUserID: number
  FormFoxTestAN: number
  RequestToken: string
  ExpiredAt: Date
  CreatedAt: Date
  RequestText: string
  SendLink: boolean
  SendCallback: boolean
  IsFFOrder: boolean
  HideAuthESS: boolean
}

export interface ServicePriceTierParameter {
  ServiceCode: string
  ServicePriceTier: string
}

export interface SetTestDetailVendorParameters {
  formFoxTestAN: number
  collectionVendorID: number
  formFoxVendorAN: number
  FFVendorCode: string
  collectorVendorName: string
  servicePriceTiers: ServicePriceTierParameter[]
  ssoToken?: string
  expirationDate?: string
  timeZone: string
  sendLink: boolean
  sendCallback: boolean
  isFFOrder: boolean
  ReferenceTestID: number
  ProceedImmediately:boolean
  ExtendExpirationHours: number
  IsMarketPlace?: boolean
  ClinicWasUpdated?: boolean
}

export function GetEmbededTestEventWithDetail(formFoxTestAN: number) {
  const requestBody: string = JSON.stringify({
    FormFoxTestAN: formFoxTestAN
  })
  return ObservableFromFetch<EmbededTestEventWithDetail[]>("Workforceorder/GetEmbededTestEventWithDetail", requestBody)
}

export function GetFFTestData(token: string) {
  const requestBody: string = new URLSearchParams({
    requestToken: token
  }).toString()
  return ObservableFromFetch<FFSiteSearchData>("Workforceorder/GetFFTestData?" + requestBody)
}

export function SetTestDetailVendor(parameters: SetTestDetailVendorParameters) {
  const requestBody: string = JSON.stringify(parameters)
  return ObservableFromFetch<OrderData | string>("Workforceorder/SetTestDetailVendor", requestBody)
}

export function SetFFTestDetailVendor(parameters: SetTestDetailVendorParameters) {
  const requestBody: string = JSON.stringify(parameters)
  return ObservableFromFetch<string>("Workforceorder/SetTestDetailVendor", requestBody)
}

export function GetOrderRequest(token: string) {
  const requestBody: string = new URLSearchParams({
    requestToken: token
  }).toString()

  return ObservableFromFetch<PendingOrderRequest>("WorkforceApiRequest/GetApiRequest?" + requestBody)
}

export function GetOrderRequestData(token: string) {
  const requestBody: string = new URLSearchParams({
    requestToken: token
  }).toString()

  return ObservableFromFetch<SSOOrderRequestData>("WorkforceApiRequest/GetApiRequestData?" + requestBody)
}
